import { observable, action } from 'mobx';
import agent from '../../api/agent';
import navigatorStore from '../../stores/navigatorStore';

class ArtworkStore {
    @observable paginationLimit = 20;
    @observable paginationOffset = 0;
    @observable paginationOffsetPeople = 0;
    @observable paginationOffsetArtistsSearch = 0;
    @observable paginationOffsetArtists = 0;
    @observable resettingSearchkW = false;

    @action getAllArtworks(query, hideTheLoader) {
        return agent.Artworks.getAll(query, { limit: this.paginationLimit, offset: parseInt(this.paginationOffset) }, hideTheLoader)
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getAllArtists(query, hideTheLoader) {
        return agent.Artists.getAllArtists(query, { limit: this.paginationLimit, offset: parseInt(this.paginationOffsetPeople) }, hideTheLoader)
            .catch(action(err => {
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getAllArtistsList(query, hideTheLoader) {
        return agent.Artists.getAllArtists(query, { limit: this.paginationLimit, offset: parseInt(this.paginationOffsetArtists) }, hideTheLoader)
            .catch(action(err => {
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getAllArtistsSearch(query, hideTheLoader) {
        return agent.Artists.getAllArtists(query, { limit: this.paginationLimit, offset: parseInt(this.paginationOffsetArtistsSearch) }, hideTheLoader)
            .catch(action(err => {
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getAllArtistsCountry(query, hideTheLoader) {
        return agent.Artists.getAllArtistsCountry(query,
            { limit: this.paginationLimit, offset: parseInt(this.paginationOffsetArtists) },
            hideTheLoader)
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getAllArtistsMedium(query, hideTheLoader) {
        return agent.Artists.getAllArtistsMedium(query,
            { limit: this.paginationLimit, offset: parseInt(this.paginationOffsetArtists) },
            hideTheLoader)
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal(err);
            }))
    }
    @action resetSearchKeyword() {
        this.resettingSearchkW = true;
    }
    @action stopResetSearchKeyword() {
        this.resettingSearchkW = false;
    }
    @action getInitialResultsArtworks(query) {
        return agent.Artworks.getAll(query, { limit: 4, offset: parseInt(0) })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal(err);
            }))
    }
    @action getInitialResultsArtists(query) {
        return agent.Artists.getAllArtists(query, { limit: 4, offset: parseInt(0) })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                navigatorStore.openErrorModal(err);
            }))
    }
    @action loadmore() {
        // console.log("came here")
        this.paginationOffset = this.paginationOffset + this.paginationLimit;
        // this.paginationLimit = this.paginationLimit + 25;
        // console.log(this.paginationOffset)
        // this.getAllArtworks()
    }
    @action loadmoreArtists() {
        // console.log("came here")
        this.paginationOffsetArtists = this.paginationOffsetArtists + this.paginationLimit;
        // console.log(this.paginationOffset)
    }
    @action loadmoreArtistsSearch() {
        // console.log("came here")
        this.paginationOffsetArtistsSearch = this.paginationOffsetArtistsSearch + this.paginationLimit;
    }
    @action loadmoreArtistsPeople() {
        // console.log("came here")
        this.paginationOffsetArtistsPeople = this.paginationOffsetArtistsPeople + this.paginationLimit;
    }

    @action resetPagination() {
        this.paginationOffset = 0
        this.paginationOffsetArtistsSearch = 0
        this.paginationOffsetArtists = 0
        this.paginationOffsetPeople = 0
    }
  
}
export default new ArtworkStore();


// WEBPACK FOOTER //
// ./src/stores/artworksStores/searchPageArtworksStore.js